import { createContext, useContext } from 'react';

export const EnterpriseAdminSearchContext = createContext(false);
export const useEnterpriseAdminSearchContext = () => useContext(EnterpriseAdminSearchContext);
